
import { buildAlarms } from "./alarm.js";
import { buildRuuvi } from "./ruuvi.js";
import { MapConfig } from "types/Farm.js";



export enum COMPONENTS {
	CMP_1 = "VBS01",
	CMP_2 = "VBS02",
	CMP_3 = "VBS03",
	CMP_4 = "VBS04",
	CMP_5 = "VBS05",
	HVAC = "HVAC",
	GERM = "GERM",
}

// export enum COMPONENTS {
// 	GU1 = "CAPRIOLUS1",
// 	GU2 = "CAPRIOLUS1",
// 	GU3 = "CAPRIOLUS1",
// 	GU4 = "CAPRIOLUS1",
// 	GU5 = "CAPRIOLUS1",
// 	HVAC = "HVAC",
// 	GERM = "GERM",
// }


export function create() {
	const mapDescriptor:MapConfig = {
		svgName: "capriolo",
		templateName: "capriolo",
		//gFactor: 2,
		//zoomInit: .56,
		//posInit: { x: 35, y: -250 },
		alerts: buildAlarms(),
		ruuvi: buildRuuvi(),
	}
	return mapDescriptor
}